<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-icon size="small" :color="color" :icon="icon" />
      <slot />
    </v-col>
  </v-row>
</template>

<script setup>
import { computed } from "vue";
import { mdiCheck, mdiClose } from "@mdi/js";

const props = defineProps({
  valid: {
    type: Boolean,
    default: false,
  },
});

const icon = computed(() => {
  return props.valid ? mdiCheck : mdiClose;
});

const color = computed(() => {
  return props.valid ? "green" : "red";
});
</script>

<style scoped></style>
